var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 411,
    viewBox: "0 0 452 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_91_30907)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.5 84C100.472 84 96.609 85.6002 93.7608 88.4483C90.9127 91.2965 89.3125 95.1595 89.3125 99.1875V311.812C89.3125 315.84 90.9127 319.704 93.7608 322.552C96.609 325.399 100.472 327 104.5 327H347.5C351.528 327 355.391 325.399 358.239 322.552C361.087 319.704 362.688 315.84 362.688 311.812V144.75C362.688 140.722 361.087 136.859 358.239 134.011C355.391 131.163 351.528 129.562 347.5 129.562H218.941C208.785 129.562 199.3 124.487 193.667 116.037L172.309 84H104.5ZM72.2825 66.97C80.8271 58.4253 92.4161 53.625 104.5 53.625H172.309C182.465 53.625 191.949 58.7007 197.583 67.151L218.941 99.1875H347.5C359.585 99.1875 371.173 103.988 379.717 112.532C388.262 121.077 393.062 132.666 393.062 144.75V311.812C393.062 323.897 388.262 335.485 379.717 344.03C371.173 352.574 359.585 357.375 347.5 357.375H104.5C92.4161 357.375 80.8271 352.574 72.2825 344.03C63.7378 335.485 58.9375 323.897 58.9375 311.812V99.1875C58.9375 87.1036 63.7378 75.5146 72.2825 66.97Z",
    fill: "#FFF5DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_91_30907",
    x: 38.4344,
    y: 33.1219,
    width: 375.131,
    height: 344.756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.2516
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.682353 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_30907"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_30907",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2D);
export default __webpack_public_path__ + "static/media/step2d.13b916e9b042a69610f7bcf9a5b0c310.svg";
export { ForwardRef as ReactComponent };